import React, { Component } from "react"
import ReactDOM from "react-dom"
import OutsideClickTrigger from "../../booking/components/common/OutsideClickTrigger"
import * as htmlHelper from "../../helpers/html"

class ClassicModal extends Component {
  constructor() {
    super()

    this.state = {
      showModal: false,
    }

    this.handleCloseClick = this.handleCloseClick.bind(this)
  }

  componentDidMount() {
    if (this.props.isOpen) this.setState({ showModal: true })
  }

  handleCloseClick() {
    this.setState({ showModal: false })
    ReactDOM.unmountComponentAtNode(this.props.elem)
  }

  render() {
    if (!this.state.showModal) return ""

    const { content } = this.props

    return (
      <div className="overlay overlay--modal overlay--fixed is-active">
        <div className="modal modal--fat">
          <OutsideClickTrigger onOutsideClick={this.handleCloseClick}>
            <React.Fragment>
              <button className="button button--icon js--close-modal" onClick={this.handleCloseClick}>
                <span className="icon">
                  <svg className="svg-icon svg-icon--close-new">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                      &nbsp;
                    </use>
                  </svg>
                </span>
              </button>
              <div className="modal__content__inner">
                <div className="modal__top">
                  <header className="a--left">
                    {content.h3 ? <h3 className="headline-md"> {htmlHelper.htmlStringToReactElement(content.h3)}</h3> : null}
                    {content.richText ? <div className="rich-text">{htmlHelper.htmlStringToReactElement(content.richText)}</div> : null}
                  </header>
                </div>
                <div className="modal__middle"></div>
                <div className="modal__bottom"></div>
              </div>
            </React.Fragment>
          </OutsideClickTrigger>
        </div>
      </div>
    )
  }
}

export default ClassicModal
